import React from "react";
import "./LogoSlider.css";

const logos = [
  "/slide1.png",
  "/slide2.png",
  "slide3.png",
"/slide1.png",
  "/slide2.png",
  "slide3.png",
  "/slide1.png",
  "/slide2.png",
  "slide3.png",
 "/slide1.png",
  "/slide2.png",
  "slide3.png",
 "/slide1.png",
  "/slide2.png",
  "slide3.png",
 "/slide1.png",
  "/slide2.png",
  "slide3.png",
  "/slide1.png",
  "/slide2.png",
  "slide3.png",
];

const LogoSlider = () => {
  return (
    <div className="logo-slider">
      <div className="logo-track">
        {[...logos, ...logos].map((logo, index) => (
          <div className="logo-slide" key={index}>
            <img src={logo} alt={`Logo ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoSlider;
